import { useState, createContext } from "react";
import MUIDataTableCustomStyle from "../../Components/MUIDataTableCustomStyle";
import { Vocabulary } from "../../Utils/Vocabulary";
import { endpoints, localUrlEnum } from "../../Utils/UrlEnum";
import { ClientModel } from "../../Utils/Models";
import { Button, Chip } from "@mui/material";
import { Address } from "../../Utils/Types";
import UploadIcon from "@mui/icons-material/Upload";
import ImportExcelModal from "../ImportExcelModal";
import { ClientExcelHeader, TablesIds } from "../../Utils/Constants";
import { postData } from "../../Services/postData";
import { ETableEditAction } from "../../Utils/Enums";
import { checkIfStringContainsOnlyOneChar } from "../../Utils/Utils";
import { AxiosResponse } from "axios";

export const CRUDContext = createContext(new ClientModel());

export default function ClientsTabLegalClientTablele() {
  const [contextValue, setContextValue] = useState(new ClientModel());
  const [openImportModal, setOpenImportModal] = useState(false);
  const [triggerReload, setTriggerReload] = useState<undefined | boolean>();
  const clientsColumns = [
    {
      label: `${Vocabulary?.companyName}`,
      name: "companyName",
      options: {
        sort: false,
      },
    },
    {
      label: `${Vocabulary.email}`,
      name: "email",
      options: {
        sort: false,
      },
    },
    {
      label: `${Vocabulary.address}`,
      name: "address",
      options: {
        setCellHeaderProps: () => ({
          align: "center",
        }),
        setCellProps: () => ({
          align: "center",
        }),
        filter: false,
        sort: false,

        empty: true,
        customBodyRender: (address: Address) => {
          return <div>{address?.city}</div>;
        },
      },
    },
    {
      label: `${Vocabulary.phone}`,
      name: "phone",
      options: {
        setCellHeaderProps: () => ({
          align: "center",
        }),
        setCellProps: () => ({
          align: "center",
          minHeight: 100,
        }),
        filter: false,
        sort: false,

        empty: true,
        customBodyRender: (phones: []) => {
          return (
            <>
              {phones?.map((phone: string) =>
                phone ? (
                  <Chip
                    color="primary"
                    key={phone}
                    label={phone}
                    style={{
                      margin: 5,
                    }}
                  />
                ) : null
              )}
            </>
          );
        },
      },
    },
    {
      label: `${Vocabulary.category}`,
      name: "category",
      options: {
        sort: false,
        setCellHeaderProps: () => ({
          align: "center",
        }),
        setCellProps: () => ({
          align: "center",
          minHeight: 100,
        }),
        filter: false,
        customBodyRender: (categories: []) => {
          return (
            <>
              {categories?.map((category: any) =>
                category ? (
                  <Chip
                    key={category.name}
                    label={category.name}
                    style={{
                      margin: 5,
                      backgroundColor: "#88aa91",
                    }}
                  />
                ) : null
              )}
            </>
          );
        },
      },
    },
    {
      label: `${Vocabulary.tags}`,
      name: "tags",
      options: {
        sort: false,
        setCellHeaderProps: () => ({
          align: "center",
        }),
        setCellProps: () => ({
          align: "center",
          minHeight: 100,
        }),
        filter: false,
        customBodyRender: (tags: []) => {
          console.log("first", tags);
          return (
            <>
              {tags?.map((tag: any) =>
                tag ? (
                  <Chip
                    key={tag.name}
                    label={tag.name}
                    style={{
                      margin: 5,
                      backgroundColor: "#8a5b2c",
                      color: "white",
                    }}
                  />
                ) : null
              )}
            </>
          );
        },
      },
    },
  ];

  /**
   *
   * @param data
   */
  const importClients = (data: any) => {
    postData(endpoints.client.import, data).then((res: AxiosResponse) => {
      if (res) {
        setOpenImportModal(false);
        setTriggerReload(triggerReload !== undefined ? !triggerReload : false);
      }
    });
  };

  /**
   *
   * @param row
   * @returns
   */
  function getNewClientRow(row: any) {
    return {
      name: row.CLIENT,
      category: row.CATEGORIE,
      periodicity: row.SAPTAMANA,
      email: row.EMAIL,
      fiscalCode: row.COD_FISCAL,
      tradeRegisterNo: checkIfStringContainsOnlyOneChar(
        row.NR_REGISTRU_COMERT,
        "-"
      ),
      observations: row.OBSERVATII,
      addressDetails: row.ADRESA,
      city: row.ORAS,
      county: row.JUDET,
      country: row.TARA,
      bank: row.BANCA,
      iban: row.CONT_BANCAR,
      contactPerson: row.PERSOANA_DE_CONTACT,
      phone: row.TELEFON,
    };
  }

  return (
    <div>
      <CRUDContext.Provider value={contextValue}>
        <MUIDataTableCustomStyle
          onEditAction={ETableEditAction.REDIRECT}
          buttons={
            <Button
              onClick={() => setOpenImportModal(true)}
              style={{ marginLeft: 10 }}
              variant="contained"
            >
              <UploadIcon />
              <div style={{ marginLeft: 5 }}>{Vocabulary.import}</div>
            </Button>
          }
          rowClickURL={`${localUrlEnum.client}/`}
          title={Vocabulary.clients}
          columns={clientsColumns}
          shouldTriggerStorageUpdate={true}
          CRUDEndPoint={endpoints.client.main}
          id={TablesIds.clients}
          setContextValue={setContextValue}
          triggerReload={triggerReload}
        ></MUIDataTableCustomStyle>
        <ImportExcelModal
          headers={ClientExcelHeader}
          title={`${Vocabulary.import} ${Vocabulary.clients}`}
          openImportModal={openImportModal}
          setOpenImportModal={setOpenImportModal}
          getNewRow={getNewClientRow}
          getRowsAsArrayData={(data: any) => importClients(data)}
        />
      </CRUDContext.Provider>
    </div>
  );
}
